import userPermissionReportAllComponent from './user_permission_report.all.component';

let userPermissionReportAllModule = angular.module('userPermissionReportAll', [
])

    .component('userPermissionReportAll', userPermissionReportAllComponent)
    .name;

export default userPermissionReportAllModule;    


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/user_permission_report/all/index.js